import { render, staticRenderFns } from "./import-score.vue?vue&type=template&id=69a3f8de&scoped=true"
import script from "./import-score.vue?vue&type=script&lang=js"
export * from "./import-score.vue?vue&type=script&lang=js"
import style0 from "./import-score.vue?vue&type=style&index=0&id=69a3f8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a3f8de",
  null
  
)

export default component.exports